import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route} from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from './store';
import { tap, take } from 'rxjs/operators';
import { UserService } from '../app/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate  {
  loginStatus$: Observable<boolean>;
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private userService: UserService,
  ) {
    this.loginStatus$ = store.select(fromStore.getIsLogin);
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return this.checkLogin(url);
  }
  canLoad(route: Route): Observable<boolean> {
    const url = `/${route.path}`;
    return this.checkLogin(url);
  }
  checkLogin(url: string): Observable<boolean> {
   return this.loginStatus$.pipe(
      tap(status => {
        if (!status) {
          const pathname = window.location.pathname;
          if (pathname !== '/') {
            this.userService.SetRedirect = pathname;
          }
          this.router.navigate(['/login']);
        }
      }),
      take(1)
    );
  }
}
